import React from 'react'
import { UserProfile } from './userProfle'

export interface UserProfileContextValue {
  userId?: String
  userRole?: Role
  userProfile?: UserProfile
  hasAnyAdminRole: boolean
  isTransportationTeamRole: boolean
  isImportoUserRole: boolean
}

export enum Role {
  SADMIN,
  ADMIN,
  USER,
  VENDOR,
  TRANSPORTATION_TEAM,
  IMPORTO_USER,
}

const UserProfileContext = React.createContext<UserProfileContextValue>({
  hasAnyAdminRole: false,
  isTransportationTeamRole: false,
  isImportoUserRole: false,
})

UserProfileContext.displayName = 'UserProfileContext'

export default UserProfileContext
